module.exports = __webpack_public_path__ + "media/images/ofn-o-a560f47d600f68714e9300d97cdf6876.svg";